import script from "./DocumentsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentsView.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentsView.vue?vue&type=style&index=0&id=1d759c97&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d759c97"]])

export default __exports__